export function IconFooterYoutube(props: {className?: string}) {
  return (
    <svg
      width="32"
      height="24"
      viewBox="0 0 32 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M31.6812 5.60015C31.6812 5.60015 31.3688 3.3939 30.4062 2.42515C29.1875 1.15015 27.825 1.1439 27.2 1.0689C22.725 0.743896 16.0063 0.743896 16.0063 0.743896H15.9937C15.9937 0.743896 9.275 0.743896 4.8 1.0689C4.175 1.1439 2.8125 1.15015 1.59375 2.42515C0.63125 3.3939 0.325 5.60015 0.325 5.60015C0.325 5.60015 0 8.1939 0 10.7814V13.2064C0 15.7939 0.31875 18.3876 0.31875 18.3876C0.31875 18.3876 0.63125 20.5939 1.5875 21.5626C2.80625 22.8376 4.40625 22.7939 5.11875 22.9314C7.68125 23.1751 16 23.2501 16 23.2501C16 23.2501 22.725 23.2376 27.2 22.9189C27.825 22.8439 29.1875 22.8376 30.4062 21.5626C31.3688 20.5939 31.6812 18.3876 31.6812 18.3876C31.6812 18.3876 32 15.8001 32 13.2064V10.7814C32 8.1939 31.6812 5.60015 31.6812 5.60015ZM12.6938 16.1501V7.1564L21.3375 11.6689L12.6938 16.1501Z"
        fill="currentColor"
      />
    </svg>
  );
}
